import { useCallback } from 'react';

import { fetchNickNameAction } from '../apiActions/fetchNickNameAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useNickNameFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const baseUrl = useConfigSlice.baseUrl();
  const JSESSIONID = useConfigSlice.JSESSIONID() as string;

  return useCallback(() => {
    if (baseUrl && JSESSIONID) {
      dispatch(
        fetchNickNameAction({
          url: `${baseUrl}/api/user/screenName`,
          JSESSIONID: JSESSIONID,
        })
      );
    }
  }, [baseUrl, dispatch, JSESSIONID]);
};
